import React, {useContext, useEffect, useMemo, useState} from "react";
import {Col} from "reactstrap";
import {UserHomepageProductContext} from "../../../../index";
import {UserHomepageProductTypes} from "../../../../models";
import MediumUserPhoneHomepageProductCard from "./types/medium";
import SmallUserPhoneHomepageProductCard from "./types/small";
import LargeUserPhoneHomepageProductCard from "./types/large";

const UserPhoneHomepageProductCard = ({
                                          data: dataProps,
                                          type,
                                          isChildOfCarousel = false,
                                          onProductClicked: onProductClickedProps,
                                          onTagClicked: onTagClickedProps,
                                      }) => {
    const {enforcedHeight = null} = useContext(UserHomepageProductContext);
    const [data, setData] = useState({});

    /**
     * Listens to the changes in data and with each change:
     * - fills in the state information based on the data and whether its oldVersion or not.
     */
    useEffect(() => {
        setData({
            ...dataProps,
            id: dataProps?.id ?? dataProps.Id ?? dataProps.PartId ?? dataProps?.coverImageURL ?? 0,
            imageUrl: dataProps.cover?.url ?? dataProps.coverImage?.url ?? dataProps?.ImageUrl ?? dataProps?.coverImageURL ?? '',
            partNumber: dataProps?.partNumber ?? dataProps?.PartNumber ?? dataProps?.partNo ?? '',
            codeList: dataProps?.codeList ?? dataProps?.CodeList ?? [],
            originalPrice: dataProps?.originalPrice ?? dataProps?.OriginalPrice ?? 0,
            changedPrice: dataProps?.price ?? dataProps?.changedPrice ?? dataProps?.originalPrice ?? dataProps?.ChangedPrice ?? dataProps?.OriginalPrice ?? 0,
            saved: dataProps?.IsSaved ?? dataProps?.isSaved ?? false,
            isCompared: dataProps?.IsInCompareList ?? dataProps?.isInCompareList ?? dataProps?.isInCompare ?? false,
            category: dataProps?.category ?? dataProps?.Category,
            saving: false,
            comparing: false,
            tags: dataProps?.tags ?? [],
        });
    }, [dataProps]);

    /**
     * Calls the onTagClickedProps callback with the current product and the given tag as its arguments.
     * @param {any} tag
     */
    const onTagClicked = (tag) => onTagClickedProps(data, tag);

    /**
     * Calls the onProductClicked callback with the current product as its argument.
     */
    const onProductClicked = () => onProductClickedProps(data);

    /**
     * Renders the appropriate product based on the given type.
     * @type {JSX.Element}
     */
    const product = useMemo(() => {
        switch (type) {
            case UserHomepageProductTypes.large:
                return <LargeUserPhoneHomepageProductCard
                    data={data}
                    onClick={onProductClicked}
                    onTagClicked={onTagClicked}
                />
            case UserHomepageProductTypes.medium:
                return <MediumUserPhoneHomepageProductCard
                    data={data}
                    onClick={onProductClicked}
                    onTagClicked={onTagClicked}
                />
            case UserHomepageProductTypes.small:
                return <SmallUserPhoneHomepageProductCard
                    data={data}
                    onClick={onProductClicked}
                    onTagClicked={onTagClicked}
                />
            default:
                return <></>
        }
    }, [type, data,])


    /**
     * Renders the container that wraps the given products based on type and whether the product is child of carousel.
     *
     * * if not child of a carousel, the product is not wrapped.
     * @param {JSX.Element} product
     * @return {JSX.Element}
     */
    const productContainer = useMemo(() => {
        if (isChildOfCarousel) {
            return <div className={'product-container'}>
                {product}
            </div>;
        }
        switch (type) {
            case UserHomepageProductTypes.large:
                return <Col xs={12} className={'d-flex justify-content-center align-items-center'}>
                    {product}
                </Col>
            case UserHomepageProductTypes.medium:
                return <Col xs={10} className={'d-flex align-items-center align-items-md-start'}>
                    {product}
                </Col>
            case UserHomepageProductTypes.small:
                return <Col xs={12} md={6}>
                    {product}
                </Col>
            default:
                return <></>
        }
    }, [product, enforcedHeight, isChildOfCarousel, type])

    return (
        <>
            {productContainer}
        </>
    );
}


export default UserPhoneHomepageProductCard;
